import { getStorageToken } from 'common/utils/localStorage';
import { GraphQLClient } from 'graphql-request'
import { RequestDocument } from 'graphql-request/dist/types';

export const swrFetcher = async (query: RequestDocument, onError?: any) => {
  try {
    const client = new GraphQLClient(process.env.REACT_APP_GRAPHQL_API_URL!);

    const headers = {
      authorization: `Bearer ${getStorageToken()}`
    };

    await client.request(query, undefined, headers);
  } catch (error) {
    if (onError) {
      onError(error);
    }
  }
}